module.exports = __webpack_public_path__ + "img/discussion_sh_bg.e63b8eab.png";